<div class="lookup-wrapper">
  <motif-select
    #lookupSelect
    [id]="key()"
    [ngModel]="selectedValue"
    [labelPosition]="labelPosition()"
    [multiple]="multiple()"
    [placeholder]="placeholder()"
    [required]="ariaRequired()"
    validationInteraction="touched"
    [noResultsMessage]="noResultsMessage()"
    [filter]="true"
    (filterChange)="searchOptions($event)"
    [disabled]="isDisabled"
    [attr.aria-label]="key()"
    (selectionChange)="onSelectionChange($event)"
    (blur)="markAsTouched()">
    @for (option of options(); track option.value) {
      <motif-option [value]="option">{{ option.displayName }}</motif-option>
    }
  </motif-select>
  @if (isLoading()) {
    <span class="loader"></span>
  }
</div>
